var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.creditsBlob)?_c('VueMarkdown',{staticClass:"text-left",attrs:{"source":_vm.creditsBlob}}):_c('Loading')}
var staticRenderFns = []

export { render, staticRenderFns }